import { FC } from "react";

import { MapRecenterIcon } from "@/assets/icons";

import { twMerge } from "tailwind-merge";

import MapMenuItemControl from "../menuItemControl";

type Props = {
  onRecenter: () => void;
  className?: string;
};

const MapRecenterControl: FC<Props> = ({ onRecenter, className }) => (
  <MapMenuItemControl
    className={twMerge("rounded-lg border-[1px] border-gainsboro", className)}
    onClick={onRecenter}
    aria-label="Recenter Map"
    tooltipContent="Recenter map position."
  >
    <MapRecenterIcon className="cursor-pointer fill-dim-gray" />
  </MapMenuItemControl>
);

export default MapRecenterControl;
